import MainLayout from "../Layouts/MainLayout";
import Faq from "react-faq-component";

const data = {
    title: "Instruktioner, frågor & svar",
    rows: [
        {
            title: "Hur skapar jag en yta?",
            content: `Öppna kartan genom att klicka på "Karta" i menyn till vänster. När kartan är öppen hittar du en knapp i det nedre vänstra hörnet – tryck på den för att aktivera rita-verktyget. Därefter placerar du ut hörnen på den yta du vill skapa och slutför ritningen genom att avsluta där du började.`
        },
        {
            title: "Hur skapar jag ytor/stolpar i en redan existerande yta?",
            content:
                `Om du vill fylla en yta med stolpar börjar du med att markera den yta där stolparna ska placeras. Sedan använder du rita-verktyget för att rita ut stolparna inom den markerade ytan. Observera att stolparna endast kommer att vara synliga när ytan är markerad. Därför är det viktigt att du har rätt yta markerad när du placerar ut stolpar på kartan.`,
        },
        {
            title: "Hur kopierar jag en yta/stolpe?",
            content: `För att duplicera en yta eller stolpe markerar du först det objekt du vill kopiera. Därefter trycker du på Ctrl + U på ditt tangentbord, vilket skapar en exakt kopia av det markerade objektet. Den nya kopian kan du sedan flytta dit du vill genom att använda flytta-verktyget.`,
        },
        {
            title: "Hur redigerar jag en marker?",
            content: `Öppna Markeringar i menyn till vänster och välj den rad som motsvarar den mark du vill redigera. När du trycker på raden öppnas en meny där du som administratör kan ändra titel, beskrivning och bilder.`
        }
    ],
};

const styles = {
    // bgColor: 'white',
    titleTextColor: "black",
    rowTitleColor: "black",
    rowContentColor: 'grey',
    // rowContentColor: 'grey',
    // arrowColor: "red",
};

const config = {
    // animate: true,
    // arrowIcon: "V",
    // tabFocus: true
};

const Instructions = () => {
    return (
        <MainLayout>
            <div className="p-6 rounded-lg">

                <Faq
                    data={data}
                    styles={styles}
                    config={config}
                />

            </div>
        </MainLayout>
    );
}

export default Instructions